export class NatalChartError extends Error {
  constructor(public error: string) {
    super(error);
  }
}
